//
//
//
//
//
//
//
var script = {
  name: 'VueHackerText',

  data() {
    return {
      encoded: [],
      encodedRemaining: [],
      speedValue: 20,
      decodeInterval: null,
      typeCharacterInterval: null,
      availableCharacters: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\',
      decoder: null,
      showTypeCharacter: false
    };
  },

  props: {
    text: {
      type: String,
      required: true
    },
    speed: {
      type: String,
      default: 'medium',

      validator(speed) {
        return ['slow', 'medium', 'fast'].indexOf(speed) !== -1;
      }

    },
    mode: {
      type: String,
      default: 'hacker',

      validator(mode) {
        return ['hacker', 'stars', 'type'].indexOf(mode) !== -1;
      }

    },
    probability: {
      type: Number,
      default: 0.1,

      validator(probability) {
        return probability >= 0.005 && probability < 1;
      }

    },
    typeCharacter: {
      type: String,
      default: '|',

      validator(char) {
        // Only one character is valid
        return char.length === 1;
      }

    }
  },
  computed: {
    hackerText() {
      return this.encoded.join('');
    }

  },
  watch: {
    hackerText: function (val) {
      // clearInterval when decoder has finished by compairing hackerText to the original value.
      if (this.text === val) {
        clearInterval(this.decodeInterval);

        if (this.typeCharacterInterval) {
          clearInterval(this.typeCharacterInterval);
          this.showTypeCharacter = false;
        } // Emit decodingFinished for callback function


        this.$emit('decodeFinish');
      }
    }
  },
  methods: {
    encodeHacker() {
      return [...Array(this.text.length)].map(() => this.availableCharacters[Math.floor(Math.random() * this.availableCharacters.length)]);
    },

    encodeStars() {
      return [...Array(this.text.length)].map(() => '*');
    },

    encodeType() {
      return [...Array(this.text.length)].map(() => null);
    },

    decodeRandom() {
      // Get a random position of encoded
      let charactersRemaining = Object.keys(this.encodedRemaining);
      let randPos = charactersRemaining[Math.floor(Math.random() * charactersRemaining.length)];
      this.changeCharacterAt(randPos);
    },

    decodeFirst() {
      // Get the first encoded character of the encodedRemaining
      let pos = Object.keys(this.encodedRemaining).shift();
      this.changeCharacterAt(pos);
    },

    changeCharacterAt(pos) {
      // Choose a random character to replace at index with a probability of choosing the correct character
      let char = Math.random() < this.probability ? this.text[pos] : this.availableCharacters[Math.floor(Math.random() * this.availableCharacters.length)]; // Set encoded character at index to chosen character

      this.$set(this.encoded, pos, char); // If it's the correct character then delete index from encodedRemaining

      if (this.text[pos] === char) {
        delete this.encodedRemaining[pos];
      }
    }

  },

  created() {
    // Set decoding mode and encoded value.
    switch (this.mode) {
      case 'hacker':
        this.encoded = this.encodeHacker();
        this.decoder = this.decodeRandom;
        break;

      case 'stars':
        this.encoded = this.encodeStars();
        this.decoder = this.decodeFirst;
        break;

      case 'type':
        this.encoded = this.encodeType();
        this.decoder = this.decodeFirst;
        break;
    } // Create copy of encoded.
    // encodedRemaining is used to keep a track of which character indexes have not yet been decoded.


    this.encodedRemaining = JSON.parse(JSON.stringify(this.encoded)); // Set decoding speed

    switch (this.speed) {
      case 'fast':
        this.speedValue = 5;
        break;

      case 'medium':
        this.speedValue = 25;
        break;

      case 'slow':
        this.speedValue = 50;
        break;
    }
  },

  mounted() {
    // Enable before decoding function callback.
    this.$emit('decodeStart'); // Run decoder at speed interval

    this.decodeInterval = setInterval(() => {
      this.decoder();
    }, this.speedValue); // Alternate the visibility of the typeCharacter every 500ms

    if (this.mode === 'type') {
      this.typeCharacterInterval = setInterval(() => {
        this.showTypeCharacter = !this.showTypeCharacter;
      }, 500);
    }
  }

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.hackerText)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTypeCharacter,
      expression: "showTypeCharacter"
    }],
    staticClass: "typeCharacter",
    domProps: {
      "textContent": _vm._s(_vm.typeCharacter)
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-a5571208_0", {
    source: ".typeCharacter[data-v-a5571208]{margin-left:3px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-a5571208";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installVueHackerText(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueHackerText', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
